import { Fragment, useMemo } from 'react'
import PropTypes from 'prop-types'
import HelpTooltip from 'components/tooltip/HelpTooltip'
import Button from 'components/form/Button'
import { downloadCsvFile } from 'utils'
import api from 'api/axios/foka'
import { fail } from 'features/toast/Toast'
import moment from 'moment'
import AdAccountAfter from './aggregate/AdAccountAfter'
import CampaignAfter from './aggregate/CampaignAfter'
import AdGroupAfter from './aggregate/AdGroupAfter'
import KeywordAfter from './aggregate/KeywordAfter'
import CreativeLinkAfter from './aggregate/CreativeLinkAfter'
import BizChannelAfter from './aggregate/BizChannelAfter'
import { CampaignTypes } from '../../Codes'

const DetailHasAfter = ({ actions, aggregateType, hierarchy, subType }) => {
  const [action] = actions
  const hideAfter = useMemo(
    () =>
      aggregateType === 'KEYWORD' &&
      action?.after?.keywordType === CampaignTypes.TALK_CHANNEL,
    [aggregateType, action]
  )
  const handleDownloadCampaign = async () => {
    try {
      const response = await api.editlog.downloadCampaign(hierarchy.CAMPAIGNID)
      downloadCsvFile(
        response.data,
        `${hierarchy.CAMPAIGN}_${moment().format('YYYYMMDDHHmmss')}.csv`
      )
    } catch (error) {
      const { response } = error
      const { errorCode, errorMessage } = response.data
      if (errorCode === 404) {
        fail('삭제된 키워드가 없습니다.')
      } else {
        fail(errorMessage)
      }
    }
  }
  const handleDownloadAdGroup = async () => {
    try {
      const response = await api.editlog.downloadAdGroup(hierarchy.ADGROUPID)
      downloadCsvFile(
        response.data,
        `${hierarchy.ADGROUP}_${moment().format('YYYYMMDDHHmmss')}.csv`
      )
    } catch (error) {
      const { response } = error
      const { errorCode, errorMessage } = response.data
      if (errorCode === 404) {
        fail('삭제된 키워드가 없습니다.')
      } else {
        fail(errorMessage)
      }
    }
  }
  return hideAfter ? (
    <Fragment />
  ) : (
    <>
      <p className="subtit_layer">
        내용
        <HelpTooltip>일부 항목은 내용의 이력을 제공하지 않습니다.</HelpTooltip>
      </p>
      <table className="tbl_layer tbl_layer_cont">
        <caption className="hide_caption">변경이력 내용 안내 표</caption>
        <colgroup>
          <col style={{ width: 161 }} />
          <col />
        </colgroup>
        <tbody>
          <tr>
            <th scope="col">구분</th>
            <th scope="col">값</th>
          </tr>
          {aggregateType === 'ADACCOUNT' && action.after.status && (
            <AdAccountAfter after={action.after} />
          )}
          {aggregateType === 'CAMPAIGN' && (
            <>
              <CampaignAfter after={action.after} />
              <tr>
                <th scope="row">상세 삭제 내용</th>
                <td>
                  <div className="inner_cell">
                    <Button size="small" onClick={handleDownloadCampaign}>
                      다운로드
                    </Button>
                  </div>
                </td>
              </tr>
            </>
          )}
          {aggregateType === 'ADGROUP' && (
            <>
              <AdGroupAfter after={action.after} subType={subType} />
              <tr>
                <th scope="row">상세 삭제 내용</th>
                <td>
                  <div className="inner_cell">
                    <Button size="small" onClick={handleDownloadAdGroup}>
                      다운로드
                    </Button>
                  </div>
                </td>
              </tr>
            </>
          )}
          {aggregateType === 'KEYWORD' && <KeywordAfter after={action.after} />}
          {aggregateType === 'CREATIVE_LINK' && (
            <CreativeLinkAfter after={action.after} />
          )}
          {aggregateType === 'BIZCHANNEL' && (
            <BizChannelAfter
              after={action.after}
              type={action.type}
              subType={subType}
            />
          )}
        </tbody>
      </table>
    </>
  )
}

export default DetailHasAfter

DetailHasAfter.propTypes = {
  actions: PropTypes.array,
  aggregateType: PropTypes.string,
  hierarchy: PropTypes.object,
  subType: PropTypes.string,
}
